import { Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { BUILD_VERSION } from "../config";
import { useLocalStorage } from "../hooks";

type TOwnProps = {};
const Disclaimer = (props: TOwnProps) => {
  const { t } = useTranslation("component");
  const { configures } = useLocalStorage();
  const [disclaimerMessage, setDisclaimerMessage] = useState(
    t("disclaimer.bodyMessage")
  );
  const onClickDisclaimer = () => {
    var version = "";
    try {
      const inputString =
        (configures && configures.communityConfiguration.lastUpdated) || "";
      const date = new Date(inputString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const versionSuffix = ".1";
      version = `${year}${month}${day}${versionSuffix}`;
    } catch (error) {}
    const versionPattern = /^\d{8}\.\d+$/;
    setDisclaimerMessage(
      versionPattern.test(BUILD_VERSION) ? BUILD_VERSION : version
    );
    setTimeout(() => {
      setDisclaimerMessage(t("disclaimer.bodyMessage"));
    }, 10000);
  };

  return (
    <Grid
      container
      justifyContent="center"
      spacing={1}
      sx={(theme) => ({
        backgroundColor: "#181818",
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        opacity: "90%",
        color: "white",
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        zIndex: 9999,
      })}
    >
      <Grid item xs={12} sm={8} md={12} lg={12} xl={12}>
        <Typography
          variant="body2"
          component={"span"}
          onClick={onClickDisclaimer}
        >
          {disclaimerMessage}
        </Typography>
      </Grid>
    </Grid>
  );
};
export default Disclaimer;
